import React, { createElement } from "react"

import { NOTIFICATION_SEVERITY } from "@/utils/notification"

/**
 * Render a single notification
 * @param {object} notification - Notification object
 * @param {string|Function} notification.content - Content to display
 * @param {string} notification.severity - Notification severity level
 * @param {string} notification.title - Notification title
 * @param {string} notification.notificationId - Unique notification ID
 * @param {string} notification.type - Notification type
 * @returns {JSX.Element}
 */
function renderNotification(notification) {
  const { content = null, severity = NOTIFICATION_SEVERITY.INFO, title = null } = notification

  /**
   * Render notification content
   * @returns {JSX.Element}
   */
  function renderContent() {
    if (typeof content === "function") {
      // we give back the notification to the content function, we need to pass it to the content function because we don't know what the content function needs as props
      return createElement(content, notification)
    } else {
      return (
        <div>
          <div className="notification-title">{title}</div>
          <div className="notification-content">{content}</div>
        </div>
      )
    }
  }

  /**
   * Get unique key for notification
   * @returns {string|undefined}
   */
  function getUniqueKey() {
    if (notification.notificationId === undefined || notification.type === undefined) {
      console.error("notificationId or type is undefined", notification)
      return
    }
    return `${notification.notificationId}-${notification.type}`
  }

  return (
    <div
      className={`event-notification ${severity}`}
      key={getUniqueKey()}
    >
      {notification && renderContent()}
    </div>
  )
}

/**
 * Event notifications component
 * @component
 * @param {object} props
 * @param {Array} props.notifications - Array of notification objects
 * @returns {JSX.Element}
 */
export function EventNotifications({ notifications = [] }) {
  return (
    <div className="event-notifications">
      {notifications && notifications.map(notification => renderNotification(notification))}
    </div>
  )
}
